var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"estimateCard"},[_c('h3',{staticClass:"title title_order"},[_vm._v("基础信息")]),_c('a-row',{attrs:{"gutter":24}},_vm._l((_vm.baseFeild),function(el){return _c('a-col',{key:el.feild,attrs:{"span":8}},[_c('p',{staticClass:"p_text"},[_vm._v(" "+_vm._s(el.name)+": "+_vm._s(_vm.infor[el.feild] || '-')+" ")])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }